import React from 'react';
import ReactDOM from 'react-dom/client';

import './css/style.css';
import Main from './pages';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Main/>
  </React.StrictMode>
);
